export default {
    fullCalendarButton: {
        fr: 'Voir toutes les disponibilités',
        en: 'See all available slots',
    },
};
